/**
 * Pushes a named event onto window.dataLayer for GTM to pick up.
 * GTM listens on dataLayer.push itself, so callers only build the object.
 * Safe to call before GTM has loaded — the array is created if missing.
 */
export function pushEvent(event, data = {}) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...data });
}
